import { ResourceRecorder } from './ResourceRecorder.ts';

export class WRMResourceRecorder extends ResourceRecorder {}
